import { Component, HostListener, Input } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

@Component({
  selector: 'app-premium-discount',
  templateUrl: './premium-discount.component.html',
  styleUrls: ['./premium-discount.component.scss'],
  host: {
    '[attr.id]': 'selected.value',
  },
})
export class PremiumDiscountComponent {
  @Input() premiumDiscountModel: any = []
  @Input() fundId: string
  @Input() ticker: string
  @Input() shareSplitDate: string | null = null
  @Input() shareSplitPrice: number | null = null
  public activeTab = 0
  selected = new UntypedFormControl(0)
  innerWidth = window.innerWidth
  myTabIndex: string

  constructor(public adobeLaunchService: AdobeLaunchService) {}

  ngOnInit() {
    this.innerWidth = window.innerWidth
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth
  }

  changeTab($event) {
    this.activeTab = $event
  }

  onTabChange($event) {
    if (this.myTabIndex !== undefined) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.ticker}:Premium discount:${this.premiumDiscountModel[$event].label}`,
      )
    }
    this.selected.setValue($event)
    this.myTabIndex = this.selected.value
  }

  onSelectionChange(event) {
    if (event.value !== undefined) {
      this.activeTab = event.value
    } else {
      this.activeTab = event
    }
  }
}
